import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ICheckbox, ICheckboxProps } from '@shared/components/checkbox/checkbox.component';
import {SharedModule} from "@shared/shared.module";

export interface CalibrationModalResponse {
  isDismissed: boolean;
  dontShowAgain: boolean;
}

@Component({
  selector: 'app-calibration-modal-warning',
  templateUrl: './calibration-modal-warning.component.html',
  styleUrl: './calibration-modal-warning.component.scss',
  standalone: false,
})
export class CalibrationModalWarningComponent {
  checkBoxSelected = false;
  checkboxState: ICheckbox[];

  checkboxProps: ICheckboxProps[] = [
    {
      key: 'key',
      initialValue: false,
      disabled: false,
      class: 'custom-checkbox',
      placeholder: '',
      label: `Don't show this again`,
    },
  ];

  props = {
    title: 'Measurement Calibration Will Be Lost',
    closeButtonLabel: 'Cancel',
    actionButtonLabel: 'Proceed',
    body: `Changing the image resolution will remove any measurement calibration applied to this image. This action cannot be undone.`,
  };

  private static readonly SKIP_KEY = 'iv.skipCalibrationWarning';

  constructor(private modal: NgbActiveModal) {}

  onClickCheckbox(state: ICheckbox[]) {
    this.checkBoxSelected = state[0].value;
  }

  onProceed() {
    this.persistSkipIfChecked();
    this.modal.close({ isDismissed: false, dontShowAgain: this.checkBoxSelected });
  }

  onCancel() {
    this.persistSkipIfChecked();
    this.modal.dismiss({ isDismissed: true, dontShowAgain: this.checkBoxSelected });
  }

  private persistSkipIfChecked(): void {
    try {
      if (this.checkBoxSelected) {
        sessionStorage.setItem(CalibrationModalWarningComponent.SKIP_KEY, '1');
      }
    } catch {}
  }
}
